exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2EUCG6toNnTMa9NFoRyJz5 {\n    font-weight: 700;\n}", ""]);

// exports
exports.locals = {
	"root": "_2EUCG6toNnTMa9NFoRyJz5"
};